import {
  allowancesFilter,
  allowancesFilterSelection,
  classesListFilter,
  classesListFilterSelection,
  classTypeFilter,
  classTypeFilterSelection,
  dayCaresListFilter,
  dayCaresListFilterSelection,
  defaultAllowancesDataReceiver,
  defaultClassTypeData,
  defaultMonthData,
  defaultOrgTypesDataReceiver,
  monthFilter,
  monthFilterSelection,
  orgTypesFilter,
  orgTypesFilterSelection,
  orgsFilter,
  orgsFilterSelection,
  schoolYearFilter,
  schoolYearFilterSelection,
  studentListFilter,
  studentListFilterSelection,
} from 'app/dataProviders/filter-items'

export const filterInit = () => {
  orgTypesFilter.addDataReceiver(defaultOrgTypesDataReceiver)
  orgTypesFilter.dataReceive()
  orgTypesFilter.setStatusReady()

  allowancesFilter.addDataReceiver(defaultAllowancesDataReceiver)
  allowancesFilter.dataReceive()
  allowancesFilter.setStatusReady()

  monthFilter.updateData(
    defaultMonthData,
  )
  monthFilter.setStatusReady()

  classTypeFilter.updateData(
    defaultClassTypeData
  )
  classTypeFilter.setStatusReady()

  return () => {
    orgsFilterSelection.reset()
    orgTypesFilterSelection.reset()
    allowancesFilterSelection.reset()
    monthFilterSelection.reset()
    classTypeFilterSelection.reset()
    schoolYearFilterSelection.reset()
    dayCaresListFilterSelection.reset()
    classesListFilterSelection.reset()
    studentListFilterSelection.reset()

    orgsFilter.reset()
    orgTypesFilter.reset()
    allowancesFilter.reset()
    monthFilter.reset()
    classTypeFilter.reset()
    schoolYearFilter.reset()
    dayCaresListFilter.reset()
    classesListFilter.reset()
    studentListFilter.reset()
  }
}

export const resetToDefaultAll = () => {
  orgsFilterSelection.resetToDefault()
  orgTypesFilterSelection.resetToDefault()
  allowancesFilterSelection.resetToDefault()
  classTypeFilterSelection.resetToDefault()
  monthFilterSelection.resetToDefault()
  schoolYearFilterSelection.resetToDefault()
  dayCaresListFilterSelection.resetToDefault()
  classesListFilterSelection.resetToDefault()
  studentListFilterSelection.resetToDefault()
}
